import * as z from 'zod'
import { Location } from '~/shared/api'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel, ToManyRelation } from './core'

const attributeSchema = z.object({
  name: z.string().trim().min(1, 'Обязательное поле'),
  regionCode: z.string(),
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type RegionAttributes = z.infer<typeof attributeSchema>

export class Region extends ApiModel<typeof schema, RegionAttributes> {
  static jsonApiType = 'regions'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }

  locations(): ToManyRelation<Location, this> {
    return this.hasMany(Location)
  }
  getLocations(): Location[] {
    return this.getRelation('locations')
  }
  getRegionCode(): string {
    return this.getAttribute('regionCode')
  }

  getOption(): { id: UniqueId; label: string } {
    return {
      id: this.getRegionCode(),
      label: this.getName(),
    }
  }

  static async fetchOptions(
    taxiparkId?: UniqueId,
    filters?: { key: string; value: string }[],
  ) {
    let builder = Region.limit(100)

    if (taxiparkId) {
      builder = builder.where('taxiparkId', taxiparkId)
    }

    if (filters?.length) {
      filters.forEach((filter) => {
        builder = builder.where(filter.key, filter.value)
      })
    }

    const response = await builder.get(1)
    return response.getData().map((o) => o.getOption())
  }
}
